import React from "react";
import { formatCurrency, useModal } from "@clearabee/ui-library-native";
import { useTranslation } from "react-i18next";

interface ModalProps {
  price: number;
}

export const useCalloutChargeModal = (): [
  (props: ModalProps) => React.ReactElement,
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const [Modal, showModal] = useModal();
  const [translate] = useTranslation();

  return [
    ({ price }: ModalProps) => (
      <Modal
        color="light"
        width={550}
        onClose={() => showModal(false)}
        heading={translate("hwa.components.calloutChargeModal.title")}
      >
        {translate("hwa.components.calloutChargeModal.content", {
          price: formatCurrency(price),
        })}
      </Modal>
    ),
    showModal,
  ];
};
